import React from 'react';

const ACCENTS = ['rose', 'sage', 'orange', 'teal', 'amber', 'olive', 'pink', 'mint'];

/** Hash a calendar name to one of the eight accents, stably. */
export function accentFor(name = '') {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 9973;
  return ACCENTS[h % ACCENTS.length];
}

/** Two-letter monogram of a calendar name on a hashed accent ground. */
export function CalendarChip({ name = '', accent, monogram, size = 18, style }) {
  const a = accent || accentFor(name);
  const text = (monogram || name.slice(0, 2)).toUpperCase();
  return (
    <span style={{
      width: size, height: size, flex: 'none', display: 'inline-block', textAlign: 'center',
      background: `var(--bujo-cal-${a})`, color: 'var(--bujo-cal-ink)',
      font: `var(--bujo-fw-bold) var(--bujo-fs-badge)/${size}px var(--bujo-font-mono)`,
      ...style
    }}>{text}</span>
  );
}
